/**
 * Chamada entrante tocando neste painel (Fase 3 VoIP). Setada pelo listener
 * global (`useIncomingCallListener`), consumida pelo IncomingCallOverlay.
 */
import { create } from 'zustand';

export interface IncomingCallPayload {
  tenant_id: number;
  call_id: string;
  channel_id: number;
  channel_name: string | null;
  contact_id: number;
  contact_name: string;
  contact_phone: string | null;
  ticket_id: number | null;
  /** Dono do ticket — quando setado, só ele (+admins) recebe o toque. */
  target_user_id: number | null;
  department_id: number | null;
}

interface IncomingCallState {
  call: IncomingCallPayload | null;
  setCall: (call: IncomingCallPayload) => void;
  clear: () => void;
}

export const useIncomingCallStore = create<IncomingCallState>((set) => ({
  call: null,
  setCall: (call) => set({ call }),
  clear: () => set({ call: null }),
}));
